import React, { ReactNode } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import MCard from "components/Shared/MCard";
import { WebOrderCase, WebOrderStatusResponse } from "interfaces/Mueller.Business.Models";

interface Props {
  orderSuccess: boolean;
  errorMessages: string[] | undefined;
  cases: WebOrderCase[] | undefined;
  response: WebOrderStatusResponse,
  onPrevious: (data: any) => void;
  onNewOrder: () => void;
}

const OrderResult = (props: Props) => {

  const cardTitle = props.orderSuccess ? "Thank you for your order" : "Error Processing Order";


  let elements: ReactNode[] = [];

  // If a critical import error occurs, errorCount may be 0
  if (!props.response?.errorCount && !props.response?.failed) {
    if (props.cases.length === 1) {
      elements.push(<Typography key="single-order-message">{`Your order number is ${props.cases[0].controlIdNumber}. You will receive a confirmation e-mail shortly.`}</Typography>);
    } else {
      elements.push(<React.Fragment key="multi-order-message">
        <Typography>Your orders have been placed</Typography>
        {props.cases.map((c) => <Typography key={`order-confirm-${c.controlIdNumber}`}>{`Order #: ${c.controlIdNumber} - ${c.address}`}</Typography>)}
        <Typography>You will receive a confirmation e-mail shortly</Typography>
      </React.Fragment>);
    }
    elements.push(<Button
      key="new-order-button"
      onClick={props.onNewOrder}
      sx={{ marginTop: "16px" }}
    >New Order</Button>);
  }

  if (props.response?.errorCount || props.response?.failed) {
    if (props.cases.length > 0) {
      elements.push(
        <React.Fragment key="partial-success-message">
          <Typography>{props.cases.length} out of {props.response.recordCount} of your orders have been placed</Typography>
          {props.cases.map((c) => <Typography key={`order-confirm-${c.controlIdNumber}`}>{`Order #: ${c.controlIdNumber} - ${c.address}`}</Typography>)}
          <Typography>You will receive a confirmation e-mail shortly</Typography>
        </React.Fragment>
      );
    }

    if (props.response?.errorCount > 0) {
      elements.push(<React.Fragment key="error-count-message">
        <Typography>Import failed on {props.response.errorCount} out of {props.response.recordCount} cases</Typography>
        <Typography>For more assistance, contact customer service at 1-800-875-8339</Typography>
      </React.Fragment>);
    } else {
      elements.push(<React.Fragment key="import-failed-message">
        <Typography>Import failed. Please try again.</Typography>
        <Typography>For more assistance, contact customer service at 1-800-875-8339</Typography>
      </React.Fragment>);
    }

    if (props.cases.length === 0) {
      // dont want to give them the previous button if some cases imported, im worried about duplicate cases being ordered then
      elements.push(<Button
            key="previous-button"
            onClick={props.onPrevious}
            sx={{ marginTop: 2 }}
          >Previous</Button>);
    } else {
      elements.push(<Button
        key="new-order-button-error"
        onClick={props.onNewOrder}
        sx={{ marginTop: 2 }}
      >New Order</Button>);
    }
  }

  return <MCard title={cardTitle}>{elements}</MCard>;
};

export default OrderResult;
